module.exports = __webpack_public_path__ + "images/upgrade-prompts/peloton.995eeb3d53f362370d85.svg";